import React, { useEffect, useState } from 'react';
import { IconButton } from '@agissc/ktag-map';

interface ModalProps {
  children: React.ReactNode;
  closed?: boolean;
  onClose?: () => void;
}

const Modal = ({ children, onClose, closed = false }: ModalProps) => {
  const [isOpen, setIsOpen] = useState(true);

  const handleClose = () => {
    setIsOpen(false);
    onClose?.();
  };

  useEffect(() => {
    if (closed) {
      handleClose();
    }
  }, [closed]);

  useEffect(() => {
    const handleEscapeKey = (event: KeyboardEvent) => {
      if (event.code === 'Escape') {
        handleClose();
      }
    };

    document.addEventListener('keydown', handleEscapeKey);
    return () => document.removeEventListener('keydown', handleEscapeKey);
  }, []);

  if (!isOpen) return null;

  return (
    <div className="modal-overlayer">
      <div className="modal">
        <div className="modal__header">
          <IconButton
            icon="cross"
            additionalClassNames="modal__header-button"
            onClick={handleClose}
          />
        </div>
        <div className="modal__content">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
